import React from "react";
import "./ContactUs.css"; // Link the external CSS
import headerImage from "../../assets/contact.webp";

const ContactUs = () => {
  return (
    <div className="container">
      <div className="img-container">
        <img className="about-image1" src={headerImage} alt="Teams" />
        <div class="text-overlay">
          Get In Touch
        </div>
      </div>

      <div className="content">
        <div className="contact-info">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <h3 style={{ marginBottom: "2%" }}>Registered Office</h3>
            <p style={{ marginBottom: "2%", textAlign: "center" }}>
              1B, 1st Floor, Court Chambers, 35, Sir Vithaldas Thackersey Marg,
              New Marine Lines, Mumbai - 400020
            </p>
            <p>
              E:{" "}
              <a href="mailto:support@caprixponentia.in">
                support@caprixponentia.in
              </a>{" "}
              | Tel: +91-22-40888100
            </p>
          </div>

          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3772.7056405751456!2d72.8261467751651!3d18.940079760762675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7cefee4000001%3A0xd66f1f2c70a7db4b!2sCourt%20Chambers!5e0!3m2!1sen!2sin!4v1696417893285!5m2!1sen!2sin"
            className="map"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>

        <div className="form-container">
          <form className="form">
            <input type="text" placeholder="Name" className="input" />
            <input type="email" placeholder="Email Address" className="input" />
            <input type="tel" placeholder="Mobile Number" className="input" />
            <textarea placeholder="Message" className="textarea"></textarea>
            <button type="submit" className="submit-button">
              Submit →
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
